import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';

export interface IGenerateEmailVerifcationPinUseCase {
    execute(email: string, language: string): Promise<boolean>;
}

export class GenerateEmailVerifcationPinUseCase implements IGenerateEmailVerifcationPinUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(email: string, language: string): Promise<boolean> {
        return await this.userRepo.generateEmailVerifcationPin(email, language);
    }
}
